<template>
  <nuttrema-layout-page-content class="is-forgot">

    <nuttrema-empty-result
      v-if="_get(ResendCompletionToken, 'saved')"
      icon="fal fa-paper-plane">
      <template slot="text">
        <h1>{{ $t('label.email_send') }}</h1>
        <h4 v-html="_markdown.render($t('label.we_have_sent_an_email_containing_the_special_link'))"></h4>
        <p v-html="_markdown.render($t('label.didnt_receive_an_email'))"></p>
      </template>
    </nuttrema-empty-result>

    <form-resend-completion-token
       v-else
       class="is-no-section-border is-no-center-scroll is-center-vertical"
       theme="global"
      :ResendCompletionToken="ResendCompletionToken"
      @submit="onFormSubmit">
    </form-resend-completion-token>

  </nuttrema-layout-page-content>
</template>

<script>
import { mapActions } from 'vuex';

import NuttremaLayoutPageContent from 'components/ui/layout/nuttrema-layout-page-content';

import PageProps from 'components/mixins/page-props';
import FormResendCompletionToken from './form-resend-completion-token';

export default {
  name: 'page-resend-completion-token',
  mixins: [
    PageProps,
  ],
  components: {
    NuttremaLayoutPageContent,
    FormResendCompletionToken,
  },
  computed: {
    ResendCompletionToken() {
      return this.$store.getters.ResendCompletionToken;
    },
  },
  methods: {
    ...mapActions([
      'ProceedResendCompletionToken',
    ]),
    onFormSubmit(payload) {
      this.ProceedResendCompletionToken({
        payload,
      }).then(() => {
        this.successNotification({ message: 'message.successfully_send', label: 'label.token' });
      }).catch((error) => {
        console.error(error);
        this.errorNotification({ message: 'message.error_send', label: 'label.token' });
      });
    },
  },
  beforeDestroy() {
    this.$store.dispatch('ClearResendCompletionToken');
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/shared/resend-completion-token/page-resend-completion-token.vue